/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * DefaultPolicy.tsx
 */

import Policy from "./Policy";

export default class DefaultPolicy implements Policy {
    /**
     * canSeeUsers
     * @returns {boolean}
     */
    public canSeeUsers(): boolean {
        return false;
    }
}